<ion-content>
  <div class="template-container">
    <div class="empty-state-container">
      <span class="placeholder-emoji">🛠</span>
      <h1 class="placeholder-title">Welcome to the template builder</h1>
      <p class="placeholder-subtitle">
        Create custom Slack and email designs to easily reuse.
      </p>
      <div
        *ngIf="
          !authService.selectedProject ||
          authService.isProjectOwner(authService.selectedProject.id)
        "
      >
        <ion-button
          class="btn-large"
          style="margin: 15px 15px 30px 15px"
          (click)="newEmailTemplate()"
        >
          Create new email template
        </ion-button>
        <ion-button
          class="btn-large"
          style="margin: 15px 15px 30px 15px"
          (click)="newSlackTemplate()"
        >
          Create new Slack template
        </ion-button>
      </div>
    </div>
    <div class="side-list-container" *ngIf="myTemplates && myTemplates.length">
      <h3>My templates</h3>
      <ion-grid class="grid-no-padding">
        <ion-row>
          <ion-col size="12">
            <ion-card class="my-template-card outline-card">
              <ion-list>
                <ion-item
                  *ngFor="let tmp of myTemplates"
                  (click)="selectTemplate(tmp)"
                  button="true"
                >
                  <ion-icon
                    slot="start"
                    [name]="tmp.type === 'slack' ? 'logo-slack' : 'mail'"
                    style="margin-right: 0"
                  >
                  </ion-icon>
                  <ion-label class="template-title">
                    {{ tmp.name }}
                  </ion-label>
                  <ion-label slot="end">
                    <ng-container *ngIf="!authService.selectedProject">
                      <strong>Project:</strong>
                      {{
                        tmp.projectId
                          ? getProjectName(tmp.projectId)
                          : "All projects"
                      }}
                      &nbsp;&nbsp;
                    </ng-container>
                    <strong>Updated:</strong>
                    {{ tmp.updatedAt | date: "MMM d yyyy h:mm a" }}
                  </ion-label>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div
      class="side-list-container"
      *ngIf="sampleTemplates && sampleTemplates.length"
    >
      <h3>Try a sample template</h3>
      <ion-grid class="grid-no-padding">
        <ion-row>
          <ion-col
            size-md="6"
            size-lg="4"
            size="12"
            *ngFor="let tmp of sampleTemplates"
          >
            <ion-card
              class="my-template-card card-flex outline-card depthButton"
              (click)="selectTemplate(tmp)"
              style="height: 300px; align-items: flex-end"
            >
              <img class="cover" *ngIf="tmp.image" src="{{ tmp.image }}" />
              <ion-card-title
                style="
                  box-shadow: 0px 1px 20px 0px #57779333;
                  padding: 18px;
                  width: 100%;
                  margin: 0;
                  border-radius: 0;
                  background: var(--ion-color-light);
                "
                class="template-title"
              >
                <ion-icon
                  [name]="tmp.type === 'slack' ? 'logo-slack' : 'mail'"
                  class="padded-icon"
                ></ion-icon>
                {{ tmp.name }}
              </ion-card-title>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</ion-content>
